// Shared UpdatedBy / UpdatedOn columns appended to every master data list.
export const AUDIT_COLUMNS = [
  { key: 'updated_by', label: 'Updated By' },
  {
    key: 'updated_on',
    label: 'Updated On',
    render: (r) => (r.updated_on ? new Date(r.updated_on).toLocaleString() : '—'),
  },
];

// Label used for cAccount_Code options everywhere: "{code} - {name}".
export function accountCodeLabel(r) {
  return `${r.account_code} - ${r.account_name}`;
}

// Alphabetizes { value, label } Combobox options by label (case-insensitive).
export function sortByLabel(options) {
  return [...options].sort((a, b) => String(a.label).localeCompare(String(b.label)));
}
